import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Members from "./pages/Members";
import About from "./pages/About";
import Login from "./pages/Auth/Login";
import Signup from "./pages/Auth/Signup";
import AdminPanel from "./pages/Admin/AdminPanel";
import Layout from "./components/Layout";
import MemberPage from "./pages/MemberPage";
import StatsHistory from "./components/StatsHistory";

export default function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />
      <Route
        path="/members"
        element={
          <Layout>
            <Members />
          </Layout>
        }
      />
      <Route
        path="/member/:id"
        element={
          <Layout>
            <MemberPage />
          </Layout>
        }
      />
      <Route
        path="/about"
        element={
          <Layout>
            <About />
          </Layout>
        }
      />
      <Route
        path="/auth/login"
        element={
          <Layout>
            <Login />
          </Layout>
        }
      />
      <Route
        path="/auth/signup"
        element={
          <Layout>
            <Signup />
          </Layout>
        }
      />

      <Route
        path="/admin"
        element={
          <Layout>
            <AdminPanel />
          </Layout>
        }
      />
      {/* <Route
        path="/stats"
        element={
          <Layout>
            <StatsHistory />
          </Layout>
        }
      /> */}
    </Routes>
  );
}
